import { createRoutine } from 'redux-saga-routines';

export const addressSuggestionRoutine = createRoutine('ADDRESS/SUGGESTION');
export const clearAddressSuggestRoutine = createRoutine('ADDRESS/CLEAR_SUGGESTION');
